module.exports = __webpack_public_path__ + "img/blue-pin.bf9c0a7d.png";